import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyAAtgnPmmCcPu5sylRpdxwYXvYfKj8evkI",
  authDomain: "realidaaumentada-e3ec5.firebaseapp.com",
  projectId: "realidaaumentada-e3ec5",
  storageBucket: "realidaaumentada-e3ec5.firebasestorage.app",
  messagingSenderId: "422707695313",
  appId: "1:422707695313:web:c4a3574aa535bb6c25bff0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();

export { auth, db, storage, provider };